export interface FavoritesRouter {
  goToList(query?: string): void;
  goToNews(): void;
  goToFeed(): void;
  goToNewsItem(newsId: string): void;
  goToFeedItem(communityId: string, postId: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FavoritesRouter = Symbol('FavoritesRouter');
